import { render, staticRenderFns } from "./move-to-group-form.vue?vue&type=template&id=b50eef6a&scoped=true"
import script from "./move-to-group-form.vue?vue&type=script&lang=js"
export * from "./move-to-group-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50eef6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50eef6a')) {
      api.createRecord('b50eef6a', component.options)
    } else {
      api.reload('b50eef6a', component.options)
    }
    module.hot.accept("./move-to-group-form.vue?vue&type=template&id=b50eef6a&scoped=true", function () {
      api.rerender('b50eef6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/move-to-group-form.vue"
export default component.exports